module.exports = __webpack_public_path__ + "static/media/Artboard3.371bba58.png";